// extracted by mini-css-extract-plugin
module.exports = {"formatCodeButton":"formatCodeButton--2K_J_"};